import { LaravelResponse } from "@dgs/core";
import axios from "axios";
import { AirportIndexResource } from "../../../../../shared/types/airport";

const getFlightRouteKey = (request: FlightRouteRequest) => ["flight-information", request];

export const flightService = {
	getFlightRouteKey,
	getFlightRoute: (request: FlightRouteRequest) => {
		return axios.get<LaravelResponse<FlightRouteResource>>(`flight-information`, {
			params: request,
		});
	},
};

export interface FlightRouteRequest {
	flightNumber: string;
	departureDate: string;
}

export interface FlightRouteResource {
	departureLocation: AirportIndexResource;
	arrivalLocation: AirportIndexResource;
	departureDate: string;
	arrivalDate: string;
	departureTime: string;
	arrivalTime: string;
	flightNumber: string;
}
